import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import DraggableComponent from "../../../../../lib/html5-software-library/src/ranj/components/draganddrop/DraggableComponent";
import DraggableButton from "../../components/DraggableButton";

export default class ComposerTopicMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
        this._description = null;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();
        this._numberFilledAnswers = 0;
        this._answers = [];
        this._dragTargets = [];
        this._assignedDragTarget = [];

        for (let i = 0; i < ComposerTopicMediator.DROP_OPTIONS; i++) {
            this._dragTargets.push(this._target["DropZone" + (i + 1)]);
        }

        for (let i = 0; i < ComposerTopicMediator.MAX_OPTIONS; i++) {
            const optionComponent = new DraggableButton(this._target["Answer" + (i + 1)]);
            optionComponent.setLabel("Answer " + i)
            optionComponent.setDragTargets(this._dragTargets);

            //optionComponent.addEventListener.addEventListener(DraggableButton.TARGET_ENTER, this._handleDragStart2);
            optionComponent.addEventListener(DraggableButton.DRAG_START, () => this._handleDragStart(optionComponent));
            optionComponent.addEventListener(DraggableButton.DRAG_END, () => this._handleDragEnd(optionComponent));
            optionComponent.addEventListener(DraggableButton.TARGET_ENTER, (evt) => this._handleTargetEnter(optionComponent, evt.detail));
            optionComponent.addEventListener(DraggableButton.TARGET_EXIT, () => this._handleTargetExit(optionComponent));
            optionComponent.addEventListener(DraggableButton.MOVED_BACK_TO_ORIGIN, (evt) => this._handleMovedBackToOrigin(optionComponent, evt.detail));
            optionComponent.addEventListener(DraggableButton.RELEASED_ON_DRAG_TARGET, (evt) => this._handleReleaseOnDragTarget(optionComponent, evt.detail));
            optionComponent.skin.alpha = 0;
            this._answers.push(optionComponent);
        }

    }
    show() {
        return new Promise((resolve) => {
            createjs.Tween.get(this._target)
                .to({
                    alpha: 1,
                }, 450, createjs.Ease.sineOut)
                .call(() => {
                    resolve();
                });
        });
    }

    hide() {
        return new Promise((resolve) => {
            createjs.Tween.get(this._target)
                .to({
                    alpha: 0,
                }, 250, createjs.Ease.sineOut)
                .call(() => {
                    resolve();
                });
        });
    }

    hasDescription() {
        return this._description !== null;
    }

    setDescription(description) {
        this._description = description;
        this._target.topicQuestionTextField.text = description;
    }

    addAnswer(answer) {
        if (this._numberFilledAnswers < this._answers.length) {
            this._answers[this._numberFilledAnswers].setLabel(answer.getAnswerText());
            this._answers[this._numberFilledAnswers].skin.alpha = 1;
            ++this._numberFilledAnswers;
        }
    }

    _getIndexFromOption(option) {
        return this._dragTargets.indexOf(option);
    }

    _handleDragStart(draggedOptionComponent) {

    }

    _handleDragStart(draggedOptionComponent) {
    }

    _handleDragEnd(draggedOptionComponent) {
        this._target.AnswerContainer.gotoAndStop(0);
    }

    _handleTargetEnter(draggedOptionComponent, data) {
        this._target.AnswerContainer.gotoAndStop(1);
    }

    _handleTargetExit(draggedOptionComponent) {
        this._target.AnswerContainer.gotoAndStop(0);
    }

    _handleMovedBackToOrigin(draggedOptionComponent, data) {
        this._target.AnswerContainer.gotoAndStop(0);
        var dragTargetIndex = this._getIndexFromOption(data.oldTarget);
        if (this._assignedDragTarget[dragTargetIndex] !== undefined && this._assignedDragTarget[dragTargetIndex] == draggedOptionComponent) {
            delete this._assignedDragTarget[dragTargetIndex];
        }
    }

    _handleReleaseOnDragTarget(draggedOptionComponent, data) {
        this._target.AnswerContainer.gotoAndStop(0);
        var dragTargetIndex = this._getIndexFromOption(data.target);
        if (this._assignedDragTarget[dragTargetIndex] !== undefined && this._assignedDragTarget[dragTargetIndex] != draggedOptionComponent) {
            this._assignedDragTarget[dragTargetIndex].moveBackToOrigin();
            delete this._assignedDragTarget[dragTargetIndex];
        }
        this._assignedDragTarget[dragTargetIndex] = draggedOptionComponent;
    }

    destroy() {
        super.destroy();
    }
}

ComposerTopicMediator.DROP_OPTIONS = 3;
ComposerTopicMediator.MAX_OPTIONS = 6;